export default "__VITE_ASSET__N6yJEUeu__"